module.exports = __webpack_public_path__ + "img/paint.b5f7cf98.svg";